import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import { useNavigate, useSearchParams } from 'react-router-dom';
import authService from '../api/authService';

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tokenFromUrl = searchParams.get('token') || '';

  const [form, setForm] = useState({ token: tokenFromUrl, new_password: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState({ text: '', type: '' });
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleChange = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.token.trim()) {
      setMsg({ text: 'Le token de réinitialisation est requis.', type: 'danger' });
      return;
    }
    if (form.new_password !== form.confirm) {
      setMsg({ text: 'Les mots de passe ne correspondent pas.', type: 'danger' });
      return;
    }
    setLoading(true);
    setMsg({ text: '', type: '' });
    try {
      await authService.resetPassword(form.token.trim(), form.new_password);
      setMsg({ text: 'Mot de passe réinitialisé avec succès. Vous pouvez vous connecter.', type: 'success' });
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      const text = err?.response?.data?.message || 'Token invalide ou expiré.';
      setMsg({ text, type: 'danger' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#faf9f7', display: 'flex', flexDirection: 'column' }}>
      <div style={{ backgroundColor: '#8b1512', padding: '16px 0', textAlign: 'center' }}>
        <h4 className="text-white m-0" style={{ letterSpacing: '2px', fontFamily: 'serif' }}>
          MINISTÈRE CATHOLIQUE MISERICORDE
        </h4>
      </div>

      <Container className="d-flex flex-column align-items-center justify-content-center" style={{ flex: 1, paddingTop: '2rem', paddingBottom: '2rem' }}>
        <img src="/logo192.png" alt="MCM Logo" style={{ width: '140px', height: '174px', marginBottom: 24 }} />

        <Card style={{ width: '100%', maxWidth: 500, border: 'none', borderRadius: 12 }} className="shadow-sm p-4">
          <h5 className="text-center fw-bold mb-4">Nouveau mot de passe</h5>

          {msg.text && <Alert variant={msg.type} className="py-2">{msg.text}</Alert>}

          <Form onSubmit={handleSubmit}>
            {/* <Form.Group className="mb-3">
              <Form.Label className="fw-semibold" style={{ fontSize: 14 }}>
                Token de réinitialisation
              </Form.Label>
              <Form.Control
                value={form.token}
                onChange={handleChange('token')}
                placeholder="Collez ici le token reçu par e-mail"
                disabled={!!tokenFromUrl}
                style={{
                  fontFamily: 'monospace',
                  fontSize: 13,
                  backgroundColor: tokenFromUrl ? '#f0f0f0' : undefined,
                  color: tokenFromUrl ? '#555' : undefined,
                }}
              />
              {tokenFromUrl ? (
                <div style={{ fontSize: 12, color: '#2e7d32', marginTop: 4 }}>
                  ✓ Token détecté depuis le lien e-mail.
                </div>
              ) : (
                <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
                  Le token est un code long reçu dans l'e-mail de réinitialisation. Il expire après 15 minutes.
                </div>
              )}
            </Form.Group> */}

            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold" style={{ fontSize: 14 }}>Nouveau mot de passe</Form.Label>
              <div className="d-flex align-items-center border rounded px-3" style={{ height: 48 }}>
                <Form.Control
                  type={showNew ? 'text' : 'password'}
                  value={form.new_password}
                  onChange={handleChange('new_password')}
                  placeholder="Min. 8 caractères, 1 chiffre, 1 spécial"
                  style={{ border: 'none', boxShadow: 'none', padding: 0 }}
                />
                <span onClick={() => setShowNew((v) => !v)} style={{ cursor: 'pointer', color: '#888', flexShrink: 0, marginLeft: 8 }}>
                  {showNew ? <BsEyeSlash size={18} /> : <BsEye size={18} />}
                </span>
              </div>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold" style={{ fontSize: 14 }}>Confirmer le mot de passe</Form.Label>
              <div className="d-flex align-items-center border rounded px-3" style={{ height: 48 }}>
                <Form.Control
                  type={showConfirm ? 'text' : 'password'}
                  value={form.confirm}
                  onChange={handleChange('confirm')}
                  placeholder="Répéter le nouveau mot de passe"
                  style={{ border: 'none', boxShadow: 'none', padding: 0 }}
                />
                <span onClick={() => setShowConfirm((v) => !v)} style={{ cursor: 'pointer', color: '#888', flexShrink: 0, marginLeft: 8 }}>
                  {showConfirm ? <BsEyeSlash size={18} /> : <BsEye size={18} />}
                </span>
              </div>
            </Form.Group>

            <Button type="submit" disabled={loading} className="w-100 fw-bold"
              style={{ backgroundColor: '#8b1512', border: 'none', height: 48, letterSpacing: 1 }}>
              {loading ? <Spinner size="sm" animation="border" /> : 'Réinitialiser'}
            </Button>
          </Form>

          <p className="text-center mt-3 mb-0 fw-semibold text-secondary"
            style={{ cursor: 'pointer', fontSize: '16px' }}
            onClick={() => navigate('/login')}>
            ← Retour à la connexion
          </p>
        </Card>
      </Container>
    </div>
  );
}
